import { PARTNER_RECEIVED, PARTNER_CLEARED, PARTNER_COMMENTS_RECEIVED } from './actions';

const initialState = {};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case PARTNER_RECEIVED:
            return action.partner;
        case PARTNER_CLEARED:
            return initialState;
        case PARTNER_COMMENTS_RECEIVED:
            return {...state, comments: action.comments, totalComments: action.totalComments}
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/store/partner/reducer.js